import { render, staticRenderFns } from "./FamilyAccounts.vue?vue&type=template&id=0d917634&"
import script from "./FamilyAccounts.vue?vue&type=script&lang=js&"
export * from "./FamilyAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports